"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyCodes = void 0;
exports.keyCodes = {
    down: 40,
    end: 35,
    enter: 13,
    home: 36,
    left: 37,
    pagedown: 34,
    pageup: 33,
    right: 39,
    space: 32,
    tab: 9,
    up: 38,
};
//# sourceMappingURL=keyKodes.js.map